<template>
    <div class="info flex column">
        <div v-if="showTag" class="flex flex1 aic jcc pt100 pb100 column">
            <img src="../../assets/blank-default.png" alt="">
            <p class="pt15">请按序选择患者“接诊” 进行远程门诊</p>
        </div>
        <div class="flex1" v-else>
            <h3 class="flex pl15 pr15 fs18 pt10 pb10 bb">
                <span>{{info.patName}}</span>
                <span class="ml15">{{info.patIdcard|getSexFromIdCardFilter}}</span>
                <span class="ml15">{{info.patIdcard|getAgeFromIdCardFilter('岁')}}</span>
                <span class="ml15">病案号：{{info.id}}</span>
            </h3>
            <div class="tip fs12 flex jcc pt5 pb5 color_main">
                以下资料由患者提交，查看院内病历点击
                <span class="pointer ml5">HIS病历</span>
            </div>
            <div class="record-item">
                <div class="record-item-title">
                    所患疾病
                </div>
                <div class="record-item-content pl10 pt10">
                    {{info.presentingComplaint||'无'}}
                </div>
            </div>
            <div class="record-item">
                <div class="record-item-title">
                    患者主诉
                </div>
                <div class="record-item-content pl10 pt10">
                    {{info.illnessCondition||'空'}}
                </div>
            </div>
            <div class="record-item">
                <div class="record-item-title">
                    既往史
                </div>
                <div class="record-item-content pl10 pt10">
                    {{info.pastHistory||'空'}}
                </div>
            </div>
            <div class="record-item">
                <div class="record-item-title">
                    家族史
                </div>
                <div class="record-item-content pl10 pt10">
                    {{info.familyHistory||'空'}}
                </div>
            </div>
            <div class="record-item">
                <div class="record-item-title">
                    过敏史
                </div>
                <div class="record-item-content pl10 pt10">
                    {{info.allergyHistory||'空'}}
                </div>
            </div>
            <div class="record-img-wrap pl15 pr15 pt15 pb15">
                <ul class="flex">
                    <li v-for="(img,index) in info.attas" class="flex0 mb10">
                        <img :src="img.attaFileUrl" alt="" class="pointer" @click="scan(index,info.attas)">
                    </li>
                </ul>
            </div>
            <!--<div class="deal-msg color_999 fs12 pl15 pr15 pb15 flex">-->
                <!--<span class="flex1"></span>-->
                <!--<span class="flex0">{{ddxx.hyrq}}</span>-->
                <!--<span class="flex0 ml5">{{ddxx.hysj}}</span>-->
            <!--</div>-->
        </div>
        <div class="flex0 btnHeight flex aic jcc" v-if="!showTag">
            <div class="flex">
                <div class="zljl flex aic jcc pointer" @click="handler('诊疗记录')">
                    <img :src="zljlIcon" class="mr10"/>
                    诊疗记录
                </div>
                <div class="jsmz flex aic jcc ml20 pointer" @click="handler('结束问诊')" v-show="showEnd">
                    <img :src="jswmIcon" class="mr10"/>
                    结束问诊
                </div>
            </div>
        </div>
        <pic-scan ref="scan"></pic-scan>
    </div>
</template>
<script>
    import {isEmpty} from "../../lib/utils";
    import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "../../lib/filters";
    import PicScan from "../common/pic-scan";

    export default {
        name: "dis-pat-info",
        components: {PicScan},
        props: {
            info: Object,
            showControl: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                btns: [],
                zljlIcon:require('../../assets/zljl.png'),
                jswmIcon:require('../../assets/jswz.png')
            }
        },
        computed: {
            showTag() {
                return isEmpty(this.info);
            },
            showEnd(){
                return !this.info.finsh;
            }
        },
        filters: {getAgeFromIdCardFilter, getSexFromIdCardFilter},
        mixins: [],
        created() {

        },
        async mounted() {

        },
        methods: {
            scan(index, list) {
                this.$refs.scan.show(index, list.map(r => r.attaFileUrl))
            },
            handler(btn) {
                 this.$emit('btn-click', btn, this.info);
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .record-img-wrap {
        ul {
            li {
                padding-bottom: 20%;
                position: relative;
            }
        }

        img {
            position: absolute;
            max-width: 80%;
            max-height: 100%;
        }
    }

    .tip {
        background: #E6F1FC;
        border-radius: 12px;
        width: 80%;
        margin: 5px auto;
    }

    .record-item {
        margin-top: 20px;
        padding-left: 15px;
        padding-right: 15px;
        font-size: 14px;
        color: #cccccc;

        .record-item-title {
            font-weight: bold;
            color: #666666;
            margin-top: 5px;
            display: flex;
            align-items: center;

            &:before {
                margin-right: 5px;
                content: '';
                width: 3px;
                height: 14px;
                background-color: $mainColor;
            }
        }
    }

    ul {
        flex-wrap: wrap;

        li {
            width: 20%;
        }
    }

    .btnHeight{
        height: 100px;
        color:#ffffff;
    }
    .zljl{
        height: 43px;
        width:145px;
        background: #FFA063;
        border-radius: 4px;
    }
    .jsmz{
        height: 43px;
        width:145px;
        background: #F44B4B;
        border-radius: 4px;
    }
</style>

